// extracted by mini-css-extract-plugin
export default {"acciones":"TableBody_acciones__x4mdM","editIcon":"TableBody_editIcon__YTjdD","deleteIcon":"TableBody_deleteIcon__bAM9R","reactiveIcon":"TableBody_reactiveIcon__oRdjP"};